import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";

export function useCategories() {
  return useQuery({
    queryKey: ["categories", "NZ"],
    queryFn: async () => {
      const { data } = await sharedApi.get("/classifieds/categories", { params: { country: "NZ" } });
      return data.categories || [];
    },
    // Iter-241: admins can add/rename/hide/delete categories at any time.
    // A 60s staleTime + focus refetch was too "sticky" — focus events
    // during that window were no-ops, so a rename could take up to a
    // minute plus a page reload to surface. Shorter stale window +
    // background poll keeps the tree fresh without hammering the API.
    staleTime: 15_000,
    refetchOnWindowFocus: true,
    refetchInterval: 120_000,
  });
}

/** Flat list of all categories (root + child) with `path` (e.g. "cars/car-parts") */
export function useCategoriesFlat() {
  const q = useCategories();
  const flat = [];
  const walk = (nodes) => {
    for (const n of nodes || []) {
      flat.push(n);
      if (n.children?.length) walk(n.children);
    }
  };
  if (q.data) walk(q.data);
  return { ...q, flat };
}
